import * as React from 'react'

function SvgComponent(props) {
   return (
      <svg
         width={30}
         height={30}
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M10.91 0H2.726A2.73 2.73 0 000 2.727v8.182a2.73 2.73 0 002.727 2.727h8.182a2.73 2.73 0 002.727-2.727V2.727A2.73 2.73 0 0010.91 0zM27.272 0h-8.181a2.73 2.73 0 00-2.728 2.727v8.182a2.73 2.73 0 002.728 2.727h8.181A2.73 2.73 0 0030 10.91V2.727A2.73 2.73 0 0027.272 0zM10.91 16.364H2.726A2.73 2.73 0 000 19.09v8.182A2.73 2.73 0 002.727 30h8.182a2.73 2.73 0 002.727-2.727V19.09a2.73 2.73 0 00-2.727-2.727zM26.59 21.818h-2.045v-2.045a.681.681 0 00-.681-.682H22.5a.682.682 0 00-.682.682v2.045h-2.045a.682.682 0 00-.682.682v1.364c0 .376.305.681.682.681h2.045v2.046c0 .377.305.682.682.682h1.364a.681.681 0 00.681-.682v-2.046h2.046a.681.681 0 00.682-.681V22.5a.681.681 0 00-.682-.682z"
            fill={props.color || '#fff'}
         />
      </svg>
   )
}

export default SvgComponent
